import { render, staticRenderFns } from "./KgjtWebsiteTalentStrategyEdit.vue?vue&type=template&id=0a079a62&scoped=true&"
import script from "./KgjtWebsiteTalentStrategyEdit.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteTalentStrategyEdit.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteTalentStrategyEdit.vue?vue&type=style&index=0&id=0a079a62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a079a62",
  null
  
)

export default component.exports